module.exports = __webpack_public_path__ + "img/banner2.38c9f3ab.png";